import React, { Fragment, useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { TimePicker } from "react-time-picker";
import Select from "react-select";
import MenuItem from "react-select";
import { render } from "@testing-library/react";
import "../../../style/calendarclass.css";
import moment from "moment";

const FormFieldLeaveType = React.memo((props) => {
  const { inputFields, formValidation ,intimeval,outtimeval,halfdayworkval,fulldayworkval} = props;
  const [inputFieldsArr, setInputFieldsArr] = useState(null);
const[desoptions , setOptions] =useState([{}]);
let options=[];
let optionselectcom=[];
   inputFields.map(function (desig) {
    if(desig.type=="multipleselect" && desig.option.length >0)
    {
      desig.option.map((el,i) =>{
       options.push({value: el.designationId, label: el.designationName }); 
      })
     
    }
    if(desig.type=="select" && desig.option.length >0)
    {
      // optionsprop.push({value:0,label:"Select..."})
      desig.option.map((el,i) =>{
        optionselectcom.push({
          value:el.officeLocationId,label:el.address})
    })
    } 
  })

  let intim=moment(intimeval, "hhmma").format("HH:mm");
  let outtim=moment(outtimeval, "hhmma").format("HH:mm");
// const options = [
//   { value: "Spring", label: "Spring" },
//   { value: "Summer", label: "Summer" },
//   { value: "Autumn", label: "Autumn" },
//   { value: "Winter", label: "Winter" }
// ];

  return (
    <Form>
      {inputFields !== undefined
        ? inputFields.map((val, i) => {
              return (
              <FormGroup key={i} row>
                
                {/* if input field is a text or number then  */}
                {val.type === "text"? (
                  <div style={{width:'100%'}}><Label>{val.label}</Label>
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnChange(e.target.value);
                    }}   
                    value={props.formvalue}  
                  /></div>
                  
                ) : null}
                {/* <Label>{val.label}</Label> */}
                {val.type === "time"? (
                <div style={{width:'100%'}}><Label>{val.label}</Label>
                  <TimePicker onChange={(e) => {
                    val.handleOnChange(e);
                  }} placeholder={val.placeholder}
                  
                  value={moment(props.fulldayworkval, "hhmm").format("h:mm") } format="HH:mm" closeClock={false} disableClock={true} />
              
                </div>) : null}
                {val.type === "timehalf"? (
                <div style={{width:'100%'}}><Label>{val.label}</Label>
                <TimePicker onChange={(e) => {
                  val.handleOnChange(e);
                }} placeholder={val.placeholder}
                
                value={moment(props.halfdayworkval, "hhmm").format("h:mm")} format="HH:mm" closeClock={false} disableClock={true} />
            
              </div>) : null}
                {val.type === "timeAmPm"? (
                <div style={{width:'100%'}}><Label>{val.label}</Label>
                  <TimePicker onChange={(e) => {
                    val.handleOnChange(e);
                  }} placeholder={val.placeholder}
                  // value={intim} 
                  value={intimeval}
                  format="hh:mm a" closeClock={false} disableClock 

                  // locale="sv-sv"
                  />
               
                </div>) : null}
                {val.type === "timeAmPmout"? (
                <div style={{width:'100%'}}><Label>{val.label}</Label>
                <TimePicker onChange={(e) => {
                  val.handleOnChange(e);
                }} placeholder={val.placeholder}
                value={outtimeval} format="hh:mm a" closeClock={false} disableClock={true} locale="sv-sv"/>
             
              </div>) : null}
                {val.type === "number" ? (
                 <div style={{width:'100%'}}><Label>{val.label}</Label><Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnNumberChange(e.target.value);
                    }} 
                    value={props.formval} 
                  /> </div>) : null}
               {val.type === "numbermin" ? (
                  <div style={{width:'100%'}}> {val.typename==true ?(<Label>{val.label}</Label>) : null}
                  {val.label=="Minimum Working days" ? (<Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnNumberChange(e.target.value);
                    }} 
                    value={props.formval} style={{visibility: val.typename==true ? 'visible' : 'hidden' }}
                  />) : (null)}
                  
               </div> ) : null}
               {val.type === "numbertim" ? (
                  <div style={{width:'100%'}}> {val.typename==true ?(<Label>{val.label}</Label>) : null}
                  {val.label === "No Of Times" ? (<Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnNumberChange(e.target.value);
                    }} 
                    value={props.formval} style={{visibility: val.typename==true ? 'visible' : 'hidden' }}
                  />) : (null)}
                  
               </div> ) : null}
           {val.type === "radio" ?(<div style={{width:'100%'}}><FormGroup check>
                <Label check>
                  <Input type="radio" value={val.typename}  onChange={(e) => {
                      val.handleOnradioChange(e.target.value);
                    }}   name="radio1" /> {val.typename}
                </Label>
              </FormGroup>
       
              </div>) : null}
              {val.type === "radiomin" ?(<div style={{width:'100%'}}><FormGroup check>
                <Label check>
                  <Input type="radio" value={val.typename}  onChange={(e) => {
                      val.handleOnradioChange(e.target.value);
                    }}   name="radiomin" /> {val.typename}
                </Label>
              </FormGroup>
       
              </div>) : null}
              {val.type === "radiotimes" ?(<div style={{width:'100%'}}><FormGroup check>
                <Label check>
                  <Input type="radio" value={val.typename}  onChange={(e) => {
                      val.handleOnradioChange(e.target.value);
                    }}   name="radiomin" /> {val.typename}
                </Label>
              </FormGroup>
       
              </div>) : null}
              {/* {val.type === "checkbox"? (
                 <div style={{width:'100%'}}> <Label>{val.label}</Label>
                 <Input className="singleradio"
                   type={val.type}
                   placeholder={val.placeholder}
                   defaultChecked={val.value  == true ? true :false}
                   onChange={(e) => {
                     val.handleCheckbox(e.target.value);
                   }}   
                  //  value={props.checked ? props.formData.val[val.name] : null}  
                 />
                 </div>
              ) : null} */}
                {inputFieldsArr}
                {val.type === "file" ? (
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnChange(e.target.files[0]);
                    }}
                    // value={props.formData ? props.formData.val[val.name] : null}
                  />
                ) : null}
                { val.type === "select" ? (
                 
                  <Fragment>
                    <div style={{width:'100%'}}><Label>{val.label}</Label>
                    {/* <Input
                      type={val.type}
                      placeholder={val.placeholder}
                      onChange={(e) => {
                        for (let node of e.target.children) {
                          if (node.value === e.target.value) {
                            val.handleOnChange(e.target.value,node.getAttribute('data-id'));
                          }
                        }
                        
                      }}
                    >
                      <option value="0">----Select----</option>
                      {val.option.map((el, i) => (
                       <option 
                        // key={i} 
                        key={el[val.displayData["selectedData"]]}
                        data-id={el[val.displayData["selectedData"]]}
                        value={el[val.displayData["id"]]}
                        >
                          {el[val.displayData["selectedData"]]}
                        </option>
                      ))}
                    </Input> */}
                    <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={optionselectcom[0]}
        onChange={(e) => {
          val.handleOnChange(e.value,e);
        }} 
        isSearchable={true}
        value={props.formvalueloc}
        name="color"
        options={optionselectcom}
      />
                    </div>
                  </Fragment>
                ) : null}
         {val.type === "checkbox"? (
                 <div style={{width:'100%'}}> <Label>{val.label}</Label>
                 <Input className="singleradio"
                   type={val.type}
                   placeholder={val.placeholder}
                   defaultChecked={val.value  == true ? true :false}
                   onChange={(e) => {
                     val.handleCheckbox(e.target.value);
                   }}   
                  //  value={props.checked ? props.formData.val[val.name] : null}  
                 />
                 </div>
              ) : null}

                { val.type === "multipleselect" && val.option.length >0 ? (
                 
                 <Fragment>
<div style={{width:'100%'}}><Label>{val.label}</Label>
          <Select style={{color:"black"}}
        isMulti  options={options}  onChange={(e) => {
          val.handleOnChange(e[e.length-1].value);
        }}>
           
         
          </Select></div>
                 </Fragment>
               ) : null}
               
                {Object.keys(formValidation)?.length !== 0 &&
                  !formValidation?.[val.name]?.isValid && (
                    <span className=" " style={{ color: "red" }}>
                      {formValidation?.[val.name]?.errorMessage}
                    </span>
                  )}
              </FormGroup>
            );
          })
        : null}
        
      <Button
        color=""
        className="btn-admin-settings"
        onClick={props.handleSubmit}
      >
        {props.button}
      </Button>{" "}
      &nbsp;
      <Button color="" className="btn-cancel" onClick={props.toggle}>
        Cancel
      </Button>
    </Form>
  );
});

export default FormFieldLeaveType;
